import { render } from "./repository-form.vue?vue&type=template&id=47e3fa17"
import script from "./repository-form.vue?vue&type=script&lang=ts"
export * from "./repository-form.vue?vue&type=script&lang=ts"
script.render = render

export default script